/**
 * Taxonomy Configuration
 * 
 * Centralized configuration for all taxonomy types used in the application.
 * Adding a new taxonomy type only requires adding an entry here.
 */

export interface TaxonomyConfig {
  id: string;
  label: string;              // Singular: "Topic", "Subject"
  pluralLabel: string;        // Plural: "Topics", "Subjects"
  modelName: string;          // Builder.io model name
  queryField: string;         // Field path for queries
  queryParamName: string;     // URL query parameter name
  extractorKey: string;       // Key in article data
  nameField?: string;         // Field name for category name (default: 'name')
}

export const TAXONOMY_TYPES: Record<string, TaxonomyConfig> = {
  topic: {
    id: 'topic',
    label: 'Topic',
    pluralLabel: 'Topic',
    modelName: 'blog-topic',
    queryField: 'query.data.topicthemepairs.topic',
    queryParamName: 'topic',
    extractorKey: 'topicthemepairs'
  },
  
  subject: {
    id: 'subject',
    label: 'Subject',
    pluralLabel: 'Subjects',
    modelName: 'bfwsubject',
    queryField: 'query.data.subject',
    queryParamName: 'subject',
    extractorKey: 'subject'
  },
  
  discipline: {
    id: 'discipline',
    label: 'Discipline',
    pluralLabel: 'Disciplines',
    modelName: 'mlcourse',
    queryField: 'query.data.discipline',
    queryParamName: 'discipline',
    extractorKey: 'discipline',
    nameField: 'coursename'  // Discipline uses 'coursename' instead of 'name'
  },
  
  'content-series': {
    id: 'content-series',
    label: 'Content Series',
    pluralLabel: 'Content-Series',
    modelName: 'content-series',
    queryField: 'query.data.contentSeries',
    queryParamName: 'series',
    extractorKey: 'contentSeries'
  }
};

// Type-safe taxonomy type
export type TaxonomyType = keyof typeof TAXONOMY_TYPES;

// Helper to get all available taxonomy type IDs
export const AVAILABLE_TAXONOMY_TYPES = Object.keys(TAXONOMY_TYPES) as TaxonomyType[];

// Helper to get configuration
export function getTaxonomyConfig(type: TaxonomyType): TaxonomyConfig {
  return TAXONOMY_TYPES[type];
}
